import React, { Component } from 'react'
import { dateHelper } from '../../../../../../../src/helpers/date.helper'
import { ContainerTable, TablePayment, FooterPayment } from './table.style'

class Table extends Component {
	constructor(props) {
		super(props)
	}
	render() {
		const { extract } = this.props
		return (
			<ContainerTable>
				<TablePayment>
					<thead>
						<tr>
							<th>Data</th>
							<th className="mw-50">Pedido</th>
							<th>Descrição</th>
							<th>Valor em R$</th>
						</tr>
					</thead>
					<tbody>
						{extract.map((v, i) => {
							var className = v.operation == 'Débito' ? 'trDebit' : v.description == 'Pagamento recebido' ? 'trPayment' : 'trCredit';
							return (
								<tr key={i} className={className}>
									<td>
										<span>
											{dateHelper.formatDefault(new Date(v.transactionDate))} {dateHelper.getHours(new Date(v.transactionDate))}
										</span>
									</td>
									<td className={className}>
										{v.orderNumber}
									</td>
									<td className={className}>
										{v.description}
									</td>
									<td className={className}>
										{v.value ? v.value.$toReais() : ''}
									</td>
								</tr>
							)
						})}
					</tbody>
				</TablePayment>
				<FooterPayment>* Valores exibidos sem multa e juros</FooterPayment>
			</ContainerTable>
		)
	}
}

export default Table
